import React from 'react';
import styles from '../stylesheets/TelegramContactCard.module.css';

const formatTime = (timestamp) => {
  if (!timestamp) return '';
  return new Date(timestamp * 1000).toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
  });
};

const TelegramContactCard = ({ contact, isActive, onClick }) => {
  return (
    <div className={` ${styles.card} ${isActive ? styles.active : ''}`} onClick={onClick}>
      {/* Top Row */}
      <div className={styles.header}>
        <div className={`${styles.name} ch-limit-30`}>{contact.telegramName || 'Unknown User'}</div>

        <div className={styles.time}>{formatTime(contact.lastMessageTimestamp)}</div>
      </div>

      {/* Bottom Row */}
      <div className={styles.footer}>
        {contact.unreadMessages > 0 && (
          <div className={styles.unreadBadge}>{contact.unreadMessages}</div>
        )}
      </div>
    </div>
  );
};

export default TelegramContactCard;
